module.exports = __webpack_public_path__ + "img/kt-gf.12c617e0.png";